<template>
    <div class="inner-container">
        <div class="section-title budget"><i class="icon icon-calculator-coins"></i><span>{{ getCommonText('budget') }}</span></div>
        <div class="section-subtitle"><i class="icon icon-grid"></i><span>{{ $t("app.links.budget_requests") }}<budget-forms-list :curFormSelect="'/form01-123'"/></span>
            <forms-download-reprt
                :progress="progress"
                :isReportUploading="isReportUploading"
                :form="form"
                :guListLen="guListLen"
                :header="header"
                :isParentGuExist="isParentGuExist"
                :isHeadGu="isHeadGu"
                :hasDeltaRep="true"
                @checkSignatories="checkSignatories"
                @downloadRep="downloadRep"
                @downloadDeltaRep="downloadDeltaRep"
                @downloadBatchReports="downloadBatchReports"
                @downloadBatchReportsPaid="downloadBatchReportsPaid"
            ></forms-download-reprt>
        </div>
        <div class="filter-container">
            <div class="left-content">
                <budget-header v-show="categoryMode" ref="budgetHeader" :form="form" @chgData="changeHeader" :yearReq="true" :openDisabled="openDisabled" @setProgress="setProgress"></budget-header>
                <p v-if="!categoryMode" class="title">{{ getCommonText('decoding') }}. {{  cutString(currCategory[categoryFieldNames[lng]], 80) }}</p>
            </div>
            <div class="right-content">
                <template v-if="categoryMode">
                    <c-budget-forms-data-transfer
                        v-if="!isGkkpMode && !(progress < 100) && variantAttribute"
                        :header="header"
                        :lng="lng"
                        :getDataTransferText="getDataTransferText"
                        :getErrText="getErrText"
                        :makeToast="makeToast"
                        @reloadTable="loadCategoryData"
                    />
                    <div class="filter-actions filter-actions-flex">
                        <c-budget-forms-copy-rows
                            ref="cBudgetFormCopyRows"
                            v-if="isCopyRowsBtnVisible && categoryMode && variantAttribute"
                            :header="header"
                            :budgetForm="budgetForm"
                            :isHasDecodeTable="true"
                            :categoryFieldNames="categoryFieldNames"
                            :uuidv4="uuidv4"
                            :getErrText="getErrText"
                            :makeToast="makeToast"
                            @updtHeader="updtHeader"
                            @addItem="addItem"
                            @reloadTable="loadCategoryData"
                        />
                        <c-budget-forms-copy-data
                            v-if="!(progress < 100) && variantAttribute && (header.year < header.cur_year + 2)"
                            :budgetForm="budgetForm"
                            :header="header"
                            :isLoad="isLoad"
                            @keyPress="keyPress"
                        />
                        <b-button variant="primary" @click="onAddNewCat" v-if="variantAttribute" :disabled="isLoad"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</b-button>
                    </div>
                </template>
                <template v-else>
                    <b-button variant="light" @click="resetModal">
                        <i class="icon icon-keyboard icon-rotate-180"></i>{{ getCommonText('back_to_list') }}
                    </b-button>
                    <b-button :style="{ 'minWidth': '110px' }" v-if="variantAttribute" variant="primary" @click="$refs.formTemplate.addItem()">
                        <i class="icon icon-plus-circle"></i>{{ getCommonText('add') }}
                    </b-button>
                    <b-button
                        :style="{ 'minWidth': '110px' }" 
                        :disabled="!dataChanged || goodsAreSaving"
                        variant="success"
                        @click="prepareForSave">
                        {{ getCommonText('save') }}
                    </b-button>
                </template>
            </div>
        </div>

        <breadcrumbs-filter v-show="categoryMode" :header="breadcrumbsHeader" :data-type-filter="dataTypeFilter"
                            :variant-name="variantName" @openFilterByRef="openFilterByRef"/>
        <b-progress
                variant="success"
                v-show="!enteredFromOtherMode && progress < 100 && progress > 0"
                height="10px"
                :value="progress"
                striped
                animated
        ></b-progress>

        <filter-empty-placeholder v-if="enteredFromOtherMode" />
        <template v-else>
        <div v-show="categoryMode" class="table-container">
            <b-overlay :show="mainTableOverlay" rounded="sm">
            <b-table
                :fields="tableFields"
                :items="budgetForm"
                responsive="true"
                bordered
                head-variant="light"
                no-border-collapse
            >
                <template #top-row="data">
                    <td class="td-numbering"></td>
                    <td class="td-numbering"></td>
                    <td class="td-numbering text-center table-success">1</td>
                    <td class="td-numbering text-center table-danger">2</td>
                    <td class="td-numbering text-center table-info">3</td>
                    <td class="td-numbering text-center table-primary">4</td>
                    <td class="td-numbering text-center table-warning">5</td>
                    <td class="td-numbering text-center table-success">6</td>
                    <td class="td-numbering text-center table-danger">7</td>
                    <td class="td-numbering text-center table-info">8</td>
                    <td class="td-numbering text-center table-primary">9</td>
                    <td class="td-numbering text-center table-warning">10</td>
                    <td class="td-numbering"></td>
                </template>
                <template #head(selection)>
                    <div class="text-center">
                        <b-form-checkbox
                            v-model="selectAll"
                            @change="e => setIsAllDelete(e)"
                            :value="true"
                            :unchecked-value="false" />
                    </div>
                </template>
                <template #head(more)>
                    <div class="text-center">
                        <i
                            :title="getCommonText('del_selected')" 
                            class="icon icon-close table-all-remove"
                            @click="deleteItem(`${selectAll ? getCommonText('all_cats') : getCommonText('selected_cats')}`)"/>
                    </div>
                </template>
                <template #cell(selection)="data">
                    <b-form-checkbox
                        v-model="data.item.itemToDelete"
                        @input="e => { selectCheckBoxClicked(e); if (!e) selectAll = false; }"
                        :value="true"
                        :unchecked-value="false" />
                </template>
                <template #cell(action)="data">
                    <button
                        class="table-plus"
                        v-b-modal.goods-modal @click="setCurrCatName({...data.item, code: data.item.category_id})"
                        :disabled="!(data.item.recipient || data.item.recipient_kk) || data.item.nameUpdating">
                        <i class="icon icon-plus-circle"/>
                    </button>
                </template>
                <template #cell(index)="data">
                    {{ data.index + 1 }}
                </template>
                <template #cell(recipient)="data">
                    <div
                        class="column-width-100 column-width-100 bp-category-name">
                        <div>{{ data.item[categoryFieldNames[lng]] }}</div>
                        <i 
                            v-if="variantAttribute"
                            class="icon icon-pencil-edit thin-blue ml-3 pointer icon-18" 
                            @click="onEditCatName(data.item)"
                        ></i>
                    </div>
                </template>
                <template #cell(average_meals)="data">
                    <div class="text-right">{{ $n(parseInt(data.value)) }}</div>
                </template>
                <template #cell(func_day)="data">
                    <div class="text-right">{{ $n(parseInt(data.value)) }}</div>
                </template>
                <template #cell(cost_meals)="data">
                    <div class="text-right">{{ $n(data.value) }}</div>
                </template>
                <template #cell(tobacco)="data">
                    <b-form-input v-if="variantAttribute"
                                  :disabled="data.item.newCat || isEditForbidden(data.item)"
                                  class="text-right"
                                  v-model="data.item.tobacco"
                                  @update="data.item.rowToSave = true"
                                  @keyup.enter.exact="keyup13"
                                  @keypress="keyPress($event, '^\\d*\\.?\\d{0,9}$')"
                                  @change="inputFixed(data.item, 'tobacco', data.item.tobacco, 2)">
                    </b-form-input>
                    <div class="text-right" v-else>{{ $n(data.value) }}</div>
                </template>
                <template #cell(months)="data">
                    <b-form-input v-if="variantAttribute"
                                  class="text-right"
                                  :disabled="data.item.newCat || isEditForbidden(data.item)"
                                  v-model="data.item.months"
                                  @update="data.item.rowToSave = true"
                                  @keyup.enter.exact="keyup13"
                                  @keyup="checkNumber($event, 0, 12)"
                                  @keypress="keyPress($event, '^[0-9]+$')"
                                  @change="inputFixed(data.item, 'months', data.item.months, 0)">
                    </b-form-input>
                    <div class="text-right" v-else>{{ $n(data.value) }}</div>
                </template>
                <template #cell(total)="data">
                    <div class="text-right">{{ $n(data.value) }}</div>
                </template>

                <template #cell(note)="data">
                    <b-form-textarea v-if="variantAttribute"
                        style="min-height: 100px"
                        :disabled="data.item.newCat || isEditForbidden(data.item)"
                        v-model.trim="data.item.note"
                        @update="data.item.rowToSave = true"
                        @change="() => {if (data.item.recipient || data.item.recipient_kk) saveCats(data.item)}"
                        @keyup.enter.exact="keyup13"
                        :formatter="(e) => formatText(e, 100)"
                    ></b-form-textarea>
                    <div v-else>{{ data.value }}</div>
                </template>
                <template #cell(files)="data">
                    <span
                        class="blue pointer underline"
                        @click="onAllFilesClick({ ...data.item, name_ru: data.item[categoryFieldNames[lng]]})"
                    >({{data.item.files ? data.item.files.length : 0}})</span>
                </template>
                <template #cell(more)="data">
                    <i class="icon icon-clear table-remove" v-if="variantAttribute" :disabled="deletingCat" @click="deleteItem(`${getCommonText('curr_cat')}`, {...data.item, good_type: data.item}, data.index, true)"></i>
                </template>
                <template #bottom-row="data">
                    <td class="text-right" colspan="9">{{ getCommonText('total') }}</td>
                    <td class="text-right">{{ isNaN(total) ? 0 : $n(total) }}</td>
                    <td colspan="3"></td>
                </template>
            </b-table>
            </b-overlay>
            <div class="table-add" v-if="variantAttribute" :disabled="isLoad">
                <span @click="onAddNewCat"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</span>
            </div>
        </div>
        <template v-if="!categoryMode">
            <b-overlay :show="templateTableOverlay" rounded="sm">
                <form-template4
                    ref="formTemplate"
                    :formCode="form.code"
                    :goodsData="goodsData"
                    :initialGoodsData="initialGoodsData"
                    :ensTruDict="ensTruDict"
                    :variantAttribute="variantAttribute"
                    :currCategory="currCategory"
                    :lang="lang"
                    :ifAllFieldsFilled="ifAllFieldsFilled"
                    :deleteGood="deleteGood"
                    :getUnitName="getUnitName"
                    :ensTruNamePrt="ensTruNamePrt"
                    :ensTruName="ensTruName"
                    :currUnits="currUnits"
                    :descIsLoading="descIsLoading"
                    :parNameLoading="parNameLoading"
                    :allFiles="allFiles"
                    :idxOfInfl="idxOfInfl"
                    @setTotals="setTotals"
                    @prepareData="prepareData"
                    @updateDatas="updateDatas"
                    @save="save"
                    @onDataChanged="onDataChanged"
                    @searchName="searchName"
                    @checkNumber="checkNumber"
                    @setIsAllDelete="setIsAllDelete"
                    @deleteSeveralGoods="deleteSeveralGoods"
                    @doublesValidationDecodes="doublesValidationDecodes"
                    :triggDownloadFile="triggDownloadFile"
                    :triggDownloadAllFiles="triggDownloadAllFiles"
                    :showFileUploadModal="showFileUploadModal"
                    :getEnstruByName="getEnstruByName"
                    :loadCurUnits="loadCurUnits"
                    :goodsAreSaving="goodsAreSaving"
                    :isDoubleDecodeExist="isDoubleDecodeExist"
                    ></form-template4>
                <div class="table-add" v-if="variantAttribute" >
                    <span @click="$refs.formTemplate.addItem()"><i class="icon icon-plus-circle"></i> {{ getCommonText('add') }}</span>
                </div>
            </b-overlay>
        </template>
        <files-updown v-if="isFilterReady"
                      ref="filesUpdown"
            v-show="categoryMode"
            :header="header"
            :variant-attribute="variantAttribute"
            :variant-name="variantName ? variantName['pure_name_' + lng] : ''"
            :load="load"
            :showDeleteLinks="variantAttribute"
            :showDeleteAll="true"
            @getFiles="getFiles"
            @fillFilesList="fillFilesList"
            @restetFilesList="restetFilesList"
            @delelteAttachedFile="delelteAttachedFile"
            @onFilePreview="onFilePreview"
        ></files-updown>
        <modal-all-files-management
            ref="modalAllFilesManagement"
            :allFiles="allFiles"
            @triggDownloadFile="triggDownloadFile"
            @triggDownloadAllFiles="triggDownloadAllFiles"
            >
        </modal-all-files-management>
        <c-set-b-f-category-name
            ref="setCatNameModal"
            :budgetForm="budgetForm"
            :categoryFieldNames="categoryFieldNames"
            :lng="lng"
            :getCommonText="getCommonText"
            :maxNameLengthSymbls="500"
            @addItem="addItem"
            @onCatNameChanged="onCatNameChanged"
        />
        </template>
    </div>
</template>

<script>
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import BudgetHeader from '@/modules/budget-request/budget-header-new.vue';
import FilesUpdown from '@/modules/budget-request/FilesUpdown';
import BudgetFormsList from '@/modules/budget-request/components/budget-forms-list.vue';
import BreadcrumbsFilter from '@/modules/budget-request/components/breadcrumbs-filter.vue';
import FormsHandlerMixin from "./mixins/forms-handler-mixin";
import FormTemplate4 from "./components/budget-forms-template4.vue";
import ModalAllFilesManagement from './components/modal-all-files-management.vue';
import CBudgetFormsCopyData from './components/budget-forms-copy-data.vue';
import FormsDownloadReprt from "./components/forms-download-reprt.vue";
import CSetBFCategoryName from "./components/c-set-bf-category-name.vue";
import CBudgetFormsCopyRows from "./components/budget-forms-copy-rows.vue";
import CBudgetFormsDataTransfer from './components/budget-forms-data-transfer.vue';
import FilterEmptyPlaceholder from '@/modules/budget-request/components/filter-empty-placeholder.vue';

export default {
    name: 'Form02_141',
    components: {
        BudgetHeader,
        FilesUpdown,
        BudgetFormsList,
        FormsDownloadReprt,
        BreadcrumbsFilter,
        FormTemplate4,
        ModalAllFilesManagement,
        CBudgetFormsCopyData,
        CSetBFCategoryName,
        CBudgetFormsCopyRows,
        CBudgetFormsDataTransfer,
        FilterEmptyPlaceholder
    },
    mixins: [FormsHandlerMixin],
    data() {
        return {
            form: {
                code: '02-141',
                name_kk: 'Әскери қызметшiлерге, iшкi iстер органдарына, қылмыстық-атқару жүйесiне, сыбайлас жемқорлыққа қарсы қызметіне, экономикалық тергеу қызметіне, қызметкерлерiне, кәсiптiк апаттан-құтқару құрылымдарының құтқарушыларына, әскери және арнайы оқу орындарының курсанттарына, әскери мектеп-интернаттарының тәрбиеленушiлерiне тамақ өнiмдерiн сатып алуға арналған шығыстарды есептеу',
                name_ru: 'Расчет расходов на приобретение продуктов питания военнослужащих, сотрудников органов внутренних дел, уголовно-исполнительной системы, антикоррупционной службой, службы экономических расследований, спасателей профессиональных аварийно-спасательных формирований, сотрудников органов государственной противопожарной службы, курсантов военных и специальных учебных заведений, воспитанников военных школ-интернатов'
            },
            dataTypeFilter: null,
            variantAttribute: null,
            variantName: null,
            budgetForm: [],
            header: null,
            files: null,
            load: false,
            openDisabled: false,
            isLoad: false,
            inflCoefUpdatingTriesCounter: 0,
            savingTriesCounter: 0,
            categoryFieldNames: {ru: "recipient", kk: "recipient_kk"}
        };
    },
    mounted() {
        this.progress = 15;
    },

    methods: {
        fillDataForSave(item, row) {
            this.$set(item, 'category_id', this.currCategory.category_id);
            this.$set(item, 'num_meals', parseInt(row.num_meals));
            this.$set(item, 'num_day', parseInt(row.num_day));
            this.$set(item, 'norm_per', parseFloat(row.norm_per));
            this.$set(item, 'price_cur', parseFloat(row.price_cur));
            this.$set(item, 'price_indexed', parseFloat(row.price_indexed));
            this.$set(item, 'index_inf', parseFloat(row.index_inf));
        }, // заполнение полей при подготовке к сохранению товаров

        ifAllFieldsFilled() {
            const prevNewItemIdx = this.goodsData.findIndex(item => item.isNew === true);
            if (prevNewItemIdx !== -1) {
                const prevNewItem = this.goodsData[prevNewItemIdx];
                if (!prevNewItem.enstru_code) {
                    this.makeToast('warning', this.getCommonText('attention'), this.getCommonText('not_selected'));
                    return false;
                };
            }
            if (this.goodsData.findIndex(item => item.nummealsPassVal === false) !== -1) {
                this.makeToast('warning', this.getCommonText('attention'), this.getFormText('consumer_more_0'));
                return false;
            }
            if (this.goodsData.findIndex(item => item.numdayPassVal === false) !== -1) {
                this.makeToast('warning', this.getCommonText('attention'), this.getFormText('days_more_0'));
                return false;
            }
            if (this.goodsData.findIndex(item => item.normperPassVal === false) !== -1) {
                this.makeToast('warning', this.getCommonText('attention'), this.getFormText('norm_more_0'));
                return false;
            }
            if (this.goodsData.findIndex(item => item.pricecurPassVal === false) !== -1) {
                this.makeToast('warning', this.getCommonText('attention'), this.getFormText('price_more_0'));
                return false;
            }
            if (this.goodsData.findIndex(item => item.priceidxedPassVal === false) !== -1) {
                this.makeToast('warning', this.getCommonText('attention'),  this.getFormText('price_more_0'));
                return false;
            }
            if (prevNewItemIdx !== -1) this.$set(this.goodsData[prevNewItemIdx], 'isNew', false);
            return true
        },

        inputFixed(item, field, value, digit) {
            this.$nextTick(() => {
                if (!value) value = 0;
                const newVal = parseFloat(value) ? this.safeDecimal(value).toDecimalPlaces(digit).toNumber() : 0;
                this.$set(item, field, newVal);

                this.setTotal(item);

                if (!item.recipient && !item.recipient_kk) return
            this.resetSavingAtemptsLimit();
            this.saveCats(item);
            })
            
        }, // форматирует введенное значение до digit цифр после запятой

        setTotal(item) {
            const tobaco = this.safeDecimal(item.tobacco);
            const months = this.safeDecimal(item.months);
            const mult = this.safeDecimal(item.average_meals).mul(tobaco).mul(months).toDecimalPlaces(2).div(1000);
            const newTotal = mult.add(item.total_goods).toDecimalPlaces(3).toNumber();
            this.$set(item, 'total', newTotal);
        },

        itemUpdate(item, nameRu, nameKk) {
            this.$set(item, 'recipient', nameRu);
            this.$set(item, 'recipient_kk', nameKk);
            this.$set(item, 'average_meals', 0);
            this.$set(item, 'func_day', 0);
            this.$set(item, 'cost_meals', 0);
            this.$set(item, 'tobacco', 0);
            this.$set(item, 'months', 0);
            this.$set(item, 'note', '');
            this.$set(item, 'total', 0);
            this.$set(item, 'total_goods', 0);
            this.$set(item, 'rowToSave', true);
            this.$set(item, 'newCat', true);
            this.$set(item, 'oldName', nameRu);
            this.$set(item, 'oldName_kk', nameKk);
            this.$set(item, 'nameUpdating', false);
            this.$set(item, 'category_id', this.uuidv4());
            this.$set(item, 'code', item.category_id);
            this.$set(item, 'itemToDelete', false);
        },
        getFiles(data) {
            this.files = data;
        },

        keyPress: function (event, pattern) {
            const regex = new RegExp(pattern);
            const key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
            if (!regex.test(key)) {
                event.preventDefault();
                return false;
            }
        }, // вводит по заданному паттерну

        keyup13: function (event) {
            event.preventDefault();
            // Isolate the node that we're after
            const currentNode = event.target;
            // find all tab-able elements
            const allElements = document.querySelectorAll('input'); // area, object, select, [contenteditable]
            // Find the current tab index.
            const currentIndex = [...allElements].findIndex(el => currentNode.isEqualNode(el));
            // select/focus the following element
            const targetIndex = (currentIndex + 1) % allElements.length;
            if (targetIndex < allElements.length) {
                allElements[targetIndex].select();
            }
        }, // enter работает как tab

        async changeInfIdxs(cats) {
            ++this.inflCoefUpdatingTriesCounter;
            const newHeader = [{...this.header, cat_codes: cats, new_idx: this.idxOfInfl}]
            try {
                const response = await fetch('/api-py/save-budget-request-form-indexes/', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json;charset=utf-8'
                        },
                        body: JSON.stringify(newHeader)
                    });
                    if (response.status === 200) {
                        this.makeToast('warning', `${this.getCommonText('attention')}!`, this.getCommonText('infl_coef_changed'));
                        await this.loadCatData();
                    }
            } catch (error) {
                this.makeToast('danger', this.getErrText('coef_refreshing'), error.toString());
            }
        },

        async loadCategoryData() {
            this.selectAll = false;
            this.setIsCopyRowsBtnVisible(false)
            this.load = true;
            await this.loadDatas();
            await this.loadInflIdx();
            await this.loadCatData();
            this.load = false;

            this.enableCopyRowsComponent();
        },

        async loadCatData() {
            if (!this.budgetForm.length) return;
            const catIdList = [];
            this.budgetForm.forEach(item => catIdList.push(item.category_id))
            this.$set(this.header, 'cat_id_list', catIdList)
            try {
                const response = await fetch('/api-py/get-budget-request-form-cat/' + JSON.stringify(this.header));
                if (response.status === 200) {
                    const values = await response.json();
                    if (values) {
                        const catsToUpdIdx = [];
                        this.budgetForm.forEach(item => {
                            const currSums = values.find(val => val.category_id === item.category_id);
                            const idxOfInflWasChanged = this.variantAttribute && currSums && this.idxOfInfl && +currSums.avg_index_inf !== +this.idxOfInfl;
                            if (idxOfInflWasChanged) catsToUpdIdx.push(currSums.category_id);
                            if (currSums) {
                                this.$set(item, 'total_goods', this.roundNumber(currSums.sum_total_spends, 5))
                                const tobacco = this.safeDecimal(item.tobacco);
                                const months = this.safeDecimal(item.months);
                                const mult = this.safeDecimal(item.average_meals).mul(tobacco).mul(months).toDecimalPlaces(2);
                                const totalRounded = this.safeDecimal(currSums.sum_total_spends).toDecimalPlaces(5);
                                const newTotal = mult.div(1000).add(totalRounded).toDecimalPlaces(3).toNumber();
                                this.$set(item, 'total', newTotal);
                                this.$set(item, 'files', this.getUnicFilesArr(currSums));
                                if (this.variantAttribute && (item.average_meals !== Math.round(currSums.avg_num_meals) || item.func_day !== Math.round(currSums.avg_num_day) || item.cost_meals !== parseFloat(parseFloat(currSums.sum_norm_in_money).toFixed(2)))) {
                                    this.$set(item, 'average_meals', this.safeDecimal(currSums.avg_num_meals).toDecimalPlaces(0).toNumber());
                                    this.$set(item, 'func_day', this.safeDecimal(currSums.avg_num_day).toDecimalPlaces(0).toNumber());
                                    this.$set(item, 'cost_meals', this.safeDecimal(currSums.sum_norm_in_money).toDecimalPlaces(2).toNumber());
                                    this.$set(item, 'rowToSave', true);
                                    if (this.variantAttribute && this.savingTriesCounter <= 10) {
                                        ++this.savingTriesCounter;
                                        this.saveCats(item, true);
                                    }
                                }
                            } else {
                                this.$set(item, 'total', 0)
                                this.$set(item, 'files', [])
                                if (this.variantAttribute && (item.average_meals !== 0 || item.func_day !== 0 || item.cost_meals !== 0)) {
                                    this.$set(item, 'average_meals', 0);
                                    this.$set(item, 'func_day', 0);
                                    this.$set(item, 'cost_meals', 0);
                                    this.$set(item, 'rowToSave', true);
                                    if (this.variantAttribute && this.savingTriesCounter <= 10) {
                                        ++this.savingTriesCounter;
                                        this.saveCats(item, true);
                                    }
                                }
                            };

                        });
                        if (catsToUpdIdx.length) {
                            if (this.inflCoefUpdatingTriesCounter <= 10) this.changeInfIdxs(catsToUpdIdx);
                            else this.makeToast('danger', this.getErrText('warning'), this.getErrText('coef_refreshing'));
                        }
                    }
                }
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadCategoryData()`, error.toString());
            }
        },

        async loadDatas() {
            const that = this;
            this.load = true;
            let values = [];
            try {
                const response = await fetch('/api-py/get-budget-request-form/' + JSON.stringify(this.header));
                values = await response.json();
            } catch (error) {
                this.makeToast('danger', `${this.getErrText('bad_request')} loadDatas()`, error.toString());
            }
            const newBudgetForm = [];
            await values.forEach(val => {
                const item = {
                    id: val.id,
                    recipient: val.recipient,
                    recipient_kk: val.recipient_kk,
                    category_id: val.category_id,
                    code: val.category_id,
                    average_meals: val.average_meals,
                    func_day: val.func_day,
                    cost_meals: val.cost_meals,
                    tobacco: val.tobacco,
                    months: val.months,
                    total: 0,
                    total_goods: 0,
                    rowToSave: false,
                    newCat: false,
                    oldName: val.recipient,
                    oldName_kk: val.recipient_kk,
                    nameUpdating: false,
                    itemToDelete: false,
                };
                that.$set(item, 'correction_factors', val.correction_factors ? val.correction_factors : 0);
                that.$set(item, 'note', val.note ? val.note : '');
                newBudgetForm.push(item);
            });
            this.budgetForm = newBudgetForm.sort((a, b) => a.id - b.id);
            this.load = false;
        },

        async delete(item) {
            this.$set(item, 'form', this.form.code);
            this.$set(item, 'mode', this.header.mode);
            try {
                const response = await fetch('/api-py/delete-budget-request-form/', {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8'
                    },
                    body: JSON.stringify(item)
                });
                const result = await response.json();
                if ((response.status === 200) && (result.result === 'success')) {
                    this.budgetForm = this.budgetForm.filter(itm => itm.id !== item.id)
                }
            } catch {
                this.makeToast('danger', this.getErrText('warning'), this.getErrText('on_del'));
            }
        }, // удаление категорий

        number(value) {
            return (isNaN(parseFloat(value)) ? 0 : parseFloat(value));
        },

        onDataChanged(item) {
            this.$set(item, "rowToSave", true)
            this.dataChanged = true;
            this.setPassVals(item);


        }, // переключения тригера при изменении данных товаров

        prepareData(item) {
            const coeff = parseInt(item.unit_code) === 163 ? 1000 : 1;
            const price_indexed = this.safeDecimal(item.price_indexed);
            const newNormMoney = this.safeDecimal(item.norm_per).mul(price_indexed).div(coeff).toDecimalPlaces(2).toNumber();
            this.$set(item, 'norm_money', newNormMoney);
            
            const num_day = this.safeDecimal(item.num_day);
            const norm_per = this.safeDecimal(item.norm_per);
            const newYearValue = this.safeDecimal(item.num_meals).mul(num_day).mul(norm_per).div(coeff).toDecimalPlaces(3).toNumber();
            this.$set(item, 'year_value', newYearValue);
            this.setPassVals(item);
        },

        setTotals(item) {
            const rounded_price_indexed = this.safeDecimal(item.price_indexed).toDecimalPlaces(2).toNumber();
            this.$set(item, 'price_indexed', rounded_price_indexed);
            Object.defineProperty(item, 'total', {
                get: () => {
                    const idxOfInfl = this.idxOfInfl || 0;
                    const price_cur = this.safeDecimal(item.price_cur);
                    const indexedPriceCur = this.safeDecimal(item.price_cur).mul(idxOfInfl).add(price_cur).toDecimalPlaces(2).toNumber();
                    const price_indexed = item.price_indexed ? item.price_indexed : indexedPriceCur;
                    
                    const num_day = this.safeDecimal(parseInt(item.num_day));
                    const norm_per = this.safeDecimal(item.norm_per);
                    const coeff = parseInt(item.unit_code) === 163 ? 1000 : 1;
                    const year_value = this.safeDecimal(parseInt(item.num_meals)).mul(num_day).mul(norm_per).div(coeff).toDecimalPlaces(3);               
                    return this.roundNumber(this.roundNumber(price_indexed * year_value, 2) / 1000, 3);
                },
                set: function(value) {}
            });
        }, // расчет для расшифровок

        getFormCode() {
            return `${this.form.code}-decode`;
        },

        updateTotalBeforeSave(isCatDeleting = false) {
            const currTotal = isCatDeleting ? {totalAll: {
                        totalNumMeals: 0,
                        totalAvgDays: 0,
                        totalNormMoney: 0,
                        totalSpend: 0
                    }} : this.$refs.formTemplate.getTotal();
            const totalsAll = currTotal.totalAll;
            if (totalsAll.totalNumMeals >= 0 && totalsAll.totalAvgDays >= 0 && totalsAll.totalNormMoney >= 0) {
                for (const cat of this.budgetForm) {
                    if (cat.code === this.currCategory.code) {
                        this.$set(cat, 'average_meals', totalsAll.totalNumMeals);
                        this.$set(cat, 'func_day', totalsAll.totalAvgDays);
                        this.$set(cat, 'cost_meals', totalsAll.totalNormMoney);
                        this.$set(cat, 'total_goods', totalsAll.totalSpend);
                    }
                }
            }
            this.updtHeader();
        },

        getCodeFieldName() {
            return 'category_id';
        },

        isCatShouldBeSaved(row, bf) {
            return bf.id !== row.id && (bf.recipient !== bf.oldName || bf.recipient_kk !== bf.oldName_kk);
        },

        onCatNameChanged(row) {
            this.$set(row, 'rowToSave', true);
            this.prepareForSaveCats(this.budgetForm);
        }
    },
    computed: {
        total() {
            let sum = 0;
            for (const row of this.budgetForm) {
                sum += parseFloat(row.total);
            }
            return Math.ceil(sum);
        },
        averageMeals() {
            let sum = 0;
            for (const row of this.budgetForm) {
                sum += parseFloat(row.average_meals);
            }
            return sum;
        },

        getFormText() {
            return this.setFormText('form_n_141.');
        },

        tableFields() {
            if (this.$i18n.locale) {
                return [
                    {
                        key: 'selection',
                        label: ' '
                    },
                    {
                        key: 'action',
                        label: ' '
                    },
                    {
                        key: 'index',
                        label: ' № '
                    },
                    {
                        key: 'recipient',
                        label: this.getFormText('receiver_name')
                    },
                    {
                        key: 'average_meals',
                        label: this.getFormText('avg_consumer_count')
                    },
                    {
                        key: 'func_day',
                        label: this.getFormText('function_days')
                    },
                    {
                        key: 'cost_meals',
                        label: this.getFormText('day_food_norm')
                    },
                    {
                        key: 'tobacco',
                        label: this.getFormText('tobacco_norm')
                    },
                    {
                        key: 'months',
                        label: this.getFormText('months_count')
                    },
                    {
                        key: 'total',
                        label: this.getFormText('expense_sum_2')
                    },
                    {
                        key: 'note',
                        label: this.getCommonText('notes')
                    },
                    {
                        key: 'files',
                        label: this.getCommonText('files')
                    },
                    {
                        key: 'more',
                        label: ''
                    }
                ];
            };
            return [];
        }
    }
};
</script>

<style scoped>
    .error input {
        padding-left: 25px;
    }
    .filter-actions-flex {
        display: flex;
    }
    .table-plus {
        border: none;
    }
    .bp-category-name {
        display: flex;
        justify-content: space-between;
    }
    .bp-category-name .icon-pencil-edit {
        align-self: center;
    }
</style>